// @flow

import React from 'react';
import glamorous, { Span } from 'glamorous';
import t from 'app/utils/translate';

type Props = {
  isSignedIn: boolean,
  isVerified: boolean,
};

const defaultProps = {
  isSignedIn: false,
  isVerified: false,
};

const Content = glamorous.div(props => ({
  width: '100%',
  backgroundColor: props.theme.color.basis2,
  fontSize: props.theme.fontSize.small,
  fontWeight: props.theme.fontWeight.normal,
}));

const Text = glamorous.div(props => ({
  padding: props.theme.spacing.small,
}));

const Italic = glamorous.span({
  fontStyle: 'italic',
});

const EquationWrapper = glamorous.div(props => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 10,
  color: props.theme.color.basis6,
}));

const Equation = glamorous.div(props => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  fontSize: props.theme.fontSize.default,
  maxWidth: 400,
  width: '100%',
}));

const Division = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontSize: props.theme.fontSize.small,
}));

const Divider = glamorous.hr({
  marginBottom: 2,
  marginTop: 2,
  borderColor: 'white',
  width: '100%',
});

const Times = glamorous.span(props => ({
  fontSize: props.theme.fontSize.large,
}));

const Red = glamorous.span({
  color: 'red',
});

// Must be class for AnimatedGroup to work
class GlobalPointsDropDown extends React.Component<Props, any> {
  props: Props;

  render() {
    return (
      <Content>
        <Text>
          {t('The Global Points System is a way of normalizing fantasy points across all challenges to determine the Ultimate Champion for select competitions.')}
          <br />
          {t('We use the Global Points Equation below on each challenge.')}
          <br />
          {t('To eliminate the fluke factor your final Global Score is the sum of your best 3 challenges.')}
        </Text>
        <EquationWrapper>
          <Equation>
            <Division>
              {t('Your challenge score')}
              <Divider />
              <span>{t('Best possible score')}<Red>*</Red></span>
            </Division>
            <Times className="ion-ios-close-empty" />
            <span>100</span>
            <span>=</span>
            <Span textTransform="uppercase">{t('Global Points')}</Span>
          </Equation>
        </EquationWrapper>
        <Text><Red>*</Red><Italic>{t('Best possible score considers all challenge rules except for the salary cap.')}</Italic></Text>
        <Text><Italic>{t('Note: Only verified accounts appear on the leaderboard.')}</Italic></Text>
      </Content>
    );
  }
}

GlobalPointsDropDown.defaultProps = defaultProps;

export default GlobalPointsDropDown;
